import useJwt from '@core/auth/jwt/useJwt'
// import axios from '@axios'
import axios from '@/libs/http'

const { jwt } = useJwt(axios, {})
export default jwt
